import React from 'react'
import PropTypes from 'prop-types'
import Operation from '../Operation'
import {
  Constrainable,
  RemoveEmptyConstraintsOnResolve,
  TriggerMethodConstraintsOnResolve
} from '@morningtrain/react-filters'
import ExecuteOperationOnConstrain from './ExecuteOperationOnConstrain'
import SetConstrainableOnOperation from './SetConstrainableOnOperation'
import OnlyKeepOperationFilterConstraintsOnResolve from './OnlyKeepOperationFilterConstraintsOnResolve'
import SetOperationConstraintsFromEnv from './SetOperationConstraintsFromEnv'
import SetFilterMetaOnConstrainable from './SetFilterMetaOnConstrainable'
import useOperation from '../hooks/use-operation'

function ConstrainableOperation (props) {
  const operation = useOperation()

  const useParentConstrainable = props.useParentConstrainable || false

  const inner = (
    <>

      {/* Config helpers */}
      <SetConstrainableOnOperation />
      <SetFilterMetaOnConstrainable />
      <ExecuteOperationOnConstrain />
      <SetOperationConstraintsFromEnv />

      {/* Resolve helpers */}
      <RemoveEmptyConstraintsOnResolve />
      <TriggerMethodConstraintsOnResolve />
      <OnlyKeepOperationFilterConstraintsOnResolve />

      {props.children}

    </>
  )

  return (
    <Operation {...props} parentOperation={operation}>
      {useParentConstrainable ? inner : (
        <Constrainable>
          {inner}
        </Constrainable>
      )}
    </Operation>
  )
}

ConstrainableOperation.propTypes = {
  ...Operation.propTypes,
  useParentConstrainable: PropTypes.bool
}

export default ConstrainableOperation
